import i18n from 'i18next';
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import Cookies from 'js-cookie';

export function LanguageToggle() {
    const languages = [
        { code: 'pl-PL', name: 'Polski', flag: '/flags/pl.svg' },
        { code: 'en-US', name: 'English', flag: '/flags/gb.svg' },
        { code: 'uk-UA', name: 'Українська', flag: '/flags/ua.svg' }
    ];

    const [currentLanguage, setCurrentLanguage] = useState(languages[0]);
    const dropdownRef = React.useRef(null);

    useEffect(() => {
        // Check if cookie exists and set initial language
        const savedCulture = Cookies.get('UserCulture');
        if (savedCulture) {
            const savedLanguage = languages.find(lang => lang.code === savedCulture);
            if (savedLanguage) {
                setCurrentLanguage(savedLanguage);
            }
        }
    }, []);

    const changeLanguage = (language) => {
        // Cookie for React/i18n
        Cookies.set('UserCulture', language.code, { path: '/' });

        // Cookie for ASP.NET Core
        const aspNetCulture = `c=${language.code}|uic=${language.code}`;
        Cookies.set('.AspNetCore.Culture', aspNetCulture, { path: '/' });

        // Zmiana języka w i18n + reload
        i18n.changeLanguage(language.code).then(() => {
            window.location.reload();
        });

        setCurrentLanguage(language);
    };




    const showHideDropdown = () => {
        if (dropdownRef.current) {
            dropdownRef.current.click();
        }
    };

    return (
        <Dropdown className="position-relative language-dropdown">
            <div className="user-btn" onClick={showHideDropdown}>
                <img
                    src={currentLanguage.flag}
                    alt={currentLanguage.code}
                    width="25"
                    className="me-2"
                    style={{ margin: '10px 0' }}
                />
                <span>{currentLanguage.name}</span>
            </div>

            <Dropdown.Toggle
                className="position-absolute top-0 end-0 invisible pb-1 m-0 border-0"
                ref={dropdownRef}
            />
            <Dropdown.Menu className="p-0 user-nav">
                <Dropdown.Header>Wybierz język</Dropdown.Header>
                {languages.map((lang) => (
                    <Dropdown.Item
                        key={lang.code}
                        className="dropdownItem"
                        onClick={() => changeLanguage(lang)}
                        active={currentLanguage.code === lang.code}
                    >
                        <img src={lang.flag} alt={lang.code} width="20" className="me-2" />
                        <span>{lang.name}</span>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}